if (!customElements.get('payment-options-drawer')) {
  customElements.define(
    'payment-options-drawer',
    class PaymentOptionsDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('payment-options-drawer') &&
          target.id != 'ShowPaymentOptionsDrawer' &&
          target.classList.contains('togglePaymentOptionsDrawer') == false
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}

// move the drawer to body to apply global layout styles
let drawer = document.querySelector('payment-options-drawer');
if (drawer) {
  drawer.remove();
  document.body.appendChild(drawer);
  drawer = null;
}

// add any toggle to open the drawer
const toggle = document.querySelector('.togglePaymentOptionsDrawer');
if (toggle) {
  toggle.addEventListener('click', (evt) => {
    document.querySelector('payment-options-drawer').show(evt.target);
  });
}
